import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const TablaPagosVehiculos = props => {


    let op = require('../../../../src/modulos/datos');

    const headCells = [
        { id: 'anio', label: 'AÑO', width: '50px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'mes', label: 'MES', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'monto', label: 'MONTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'intereses', label: 'INTERES MORA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'recargo', label: 'RECARGOS', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'descuento', label: 'DESCUENTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'recibo', label: 'NRO. RECIBO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'fechapago', label: 'FECHA DE PAGO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
    ]

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    useEffect(() => {

        if (props.tabpago) {
            setRecords(props.tabpago);
        }

    }, [props.tabpago]);

    const imprimirHistory = (reporte) => (event) => {
        event.preventDefault();
        var id = "A.IdVehiculo=" + parseInt(props.idvehi);
        var crit = null;
        crit = " ";
        reporte = 'HisPago_Vehiculo';
        window.open(op.reportes + "/impuestovehiculo?" + "reporte=" + reporte + "&sql=" + id + "&crit=" + crit, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="content" >
                    <div className="container">
                        <div align="center" className="col-md-2 ml-auto">
                            <button style={{ marginBottom: "5px" }} onClick={imprimirHistory('HisPago_Vehiculo')} className="btn btn-primary btn-sm rounded-circle"><i className="fas fa-print"></i> </button>
                        </div>
                        <div className="row">

                            <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.anio}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.mes}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.intereses.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.recargo.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.descuento.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.recibo === null ? '' : item.recibo.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechapago).format('DD/MM/YYYY')}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaPagosVehiculos;
